// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h3","loading":"h4","b":"h5","errorMsg":"h6","loadingMsg":"h7","successMsg":"h8","hideLoadingMsg":"h9","completed":"h-","a":"h_"};